import { callService } from '@Views/utils/ServiceUtils';
import { isEmpty } from '@Views/utils/StringUtils';
import { CSSProperties, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import DaumPostcode from 'react-daum-postcode';
import { endMarkedContent } from 'pdfkit';

const CSISurveyPage1 = ({ setCSISurveyPageNo, setCsiSeq }: any) => {
    const csiSeq01Ref: any = useRef();
    const csiSeq02Ref: any = useRef();
    const csiSeq03Ref: any = useRef();
    const csiSeq04Ref: any = useRef();
    const csiSeq05Ref: any = useRef();
    const csiSeq06Ref: any = useRef();
    const csiSeq07Ref: any = useRef();
    const csiSeq08Ref: any = useRef();
    const csiSeq09Ref: any = useRef();
    const csiSeq10Ref: any = useRef();
    const csiSeq11Ref: any = useRef();


    const onChangeCsiSeq = (e: any, next: string) => {
        const { value, maxLength } = e.target;
        
        const regNumExp = /^[0-9]+$/;
        const regStrExp = /^[A-Za-z]+$/;
        const curRef = document.getElementById(e.target.id);

        if(e.target.id === "text-1" || e.target.id === 'text-2') {
            if(!regStrExp.test(value)) {
                e.target.value = null;
                if(curRef) {
                    curRef.focus();
                    return;
                }
            }
        } else {
            if(!regNumExp.test(value)) {
                e.target.value = null;
                if(curRef) {
                    curRef.focus();
                    return;
                }
            }
        }

        if (value.length === maxLength) {
            if (next) {
                const nextRef = document.getElementById(next);
                if (nextRef) {
                    nextRef.focus();
                }
            }
        }
    }

    const onKeyDownCsiSeq = (e:any) => {

        if(e.key === 'ArrowRight') {
            const nextRef = e.target.nextElementSibling;
            if(nextRef) {
                nextRef.focus();
            }
        } else if (e.key === 'ArrowLeft')  {
            const prevRef = e.target.previousElementSibling
            if(prevRef) { 
                prevRef.focus();
            }
        } else if( e.key === 'Backspace') {
            if(e.target.value !== "") {
                e.target.value = "";
                return;
            } else {
                const prevRef = e.target.previousElementSibling
                if(prevRef) { 
                    prevRef.focus();
                }
            }
        } 
    }

    const onSubmit = async () => {

        const csiSeq01 = csiSeq01Ref['current']['value'];
        const csiSeq02 = csiSeq02Ref['current']['value'];
        const csiSeq03 = csiSeq03Ref['current']['value'];
        const csiSeq04 = csiSeq04Ref['current']['value'];
        const csiSeq05 = csiSeq05Ref['current']['value'];
        const csiSeq06 = csiSeq06Ref['current']['value'];
        const csiSeq07 = csiSeq07Ref['current']['value'];
        const csiSeq08 = csiSeq08Ref['current']['value'];
        const csiSeq09 = csiSeq09Ref['current']['value'];
        const csiSeq10 = csiSeq10Ref['current']['value'];
        const csiSeq11 = csiSeq11Ref['current']['value'];

        if (isEmpty(csiSeq01) || isEmpty(csiSeq02) || isEmpty(csiSeq03) || isEmpty(csiSeq04) || isEmpty(csiSeq05) || isEmpty(csiSeq06) || isEmpty(csiSeq07) || isEmpty(csiSeq08) || isEmpty(csiSeq09) || isEmpty(csiSeq10) || isEmpty(csiSeq11)) {
            alert("고유번호가 올바르지 않습니다.");
            return;
        }

        const csiKey = csiSeq01.toUpperCase() + csiSeq02.toUpperCase() + csiSeq03 + csiSeq04 + csiSeq05 + csiSeq06 + csiSeq07 + csiSeq08 + csiSeq09 + csiSeq10 + csiSeq11;

        const res = await callService("OSUUF02R01", {csiSeq : csiKey});
        
        if (res['sucsYn'] === 'Y') {
            setCSISurveyPageNo(2)
            setCsiSeq(csiKey);
        } else {
            alert("입력하신 고유번호는 없는 번호입니다. 다시 입력해주세요.");
            return;
        }
    }

    return (
        <>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="survey-step">
                    <div className="survey-step-box">
                        <div>
                            <h2 className="survey-info-tit">소비자동향조사 의향조사</h2>
                            <p className="survey-info-p">안내드린 고유번호를 입력해주세요.</p>
                            <div className="survey-num-box">
                                <div className="form-group">
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <div className="input-group">
                                                <input className="form-control" type="text" id="text-1" maxLength={1} ref={csiSeq01Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-2")} onKeyDown={onKeyDownCsiSeq} style={{ textTransform: "uppercase" }} />
                                                <input className="form-control" type="text" id="text-2" maxLength={1} ref={csiSeq02Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-3")} onKeyDown={onKeyDownCsiSeq} style={{ textTransform: "uppercase" }} />
                                                <input className="form-control" type="text" id="text-3" maxLength={1} ref={csiSeq03Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-4")}  onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-4" maxLength={1} ref={csiSeq04Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-5")}  onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-5" maxLength={1} ref={csiSeq05Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-6")}  onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-6" maxLength={1} ref={csiSeq06Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-7")}  onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-7" maxLength={1} ref={csiSeq07Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-8")}  onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-8" maxLength={1} ref={csiSeq08Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-9")}  onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-9" maxLength={1} ref={csiSeq09Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-10")} onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-10" maxLength={1} ref={csiSeq10Ref} onChange={(e: any) => onChangeCsiSeq(e, "text-11")}onKeyDown={onKeyDownCsiSeq}/>
                                                <input className="form-control" type="text" id="text-11" maxLength={1} ref={csiSeq11Ref} onChange={(e: any) => onChangeCsiSeq(e, "submit")} onKeyDown={onKeyDownCsiSeq}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="btn-group survey-num-btn">
                            <button type="button" className="btn btn-popup positive" id="submit" title="확인" onClick={onSubmit}>확인</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


const CSISurveyPage2 = ({ msg, setCSISurveyPageNo }: any) => {


    return (
        <div className="wrap-body-center">
            <div className="bg"></div>
            <div className="survey-step">
                <div className="survey-step-box">
                    <div>
                        <h2 className="survey-info-tit">소비자동향조사 의향조사 안내</h2>
                        <div className="survey-step-p">
                            <p className="survey-info">
                                소비자 동향조사(국가승인통계 제301020호)는 소비자들의 생활형편 및 경제에 대한<br />
                                인식 전망 등을 파악하여 경제동향 분석 및 경제정책 수립 운용에 기초자료로 활용되는<br />
                                매우 중요한 통계입니다.
                            </p>
                            <p className="survey-info">
                                현재 한국은행에서는 매월 조사를 실시하고 있으며 과학적인 추출 방법으로 선정된<br />
                                전국의 약 6,500여 가구가 약 5년간 조사에 참여하고 있습니다.
                            </p>
                            <p className="survey-info">
                                표본가구로 선정되시면 2022년 상반기부터 매월 조사에 참여하시게 되며 응답하시는<br />
                                모든 내용은 통계법 제 33조 및 제 34조에 따라 엄격하게 비밀이 보장됩니다.
                            </p>
                            <p className="survey-info">
                                자세한 조사내용은 동봉한 소비자동향조사표 견본을 참고하시기 바라며,<br />
                                조사에 협조해주실 의향이 있는 가구주께서는 하단의 '기초자료조사표 작성하기'버튼을<br />
                                클릭하신 후 내용 입력을 부탁드립니다. 감사합니다.
                            </p>
                        </div>
                    </div>
                    <div className="btn-group">
                        <button type="button" className="btn btn-popup positive" title="기초자료조사표 작성하기." onClick={() => setCSISurveyPageNo(3)}>기초자료조사표 작성하기</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

const CSISurveyPage3 = ({ msg, setCSISurveyPageNo, csiSeq }: any) => {

    const [zpcd, setZpcd] = useState<string>();
    const [lctnAddr, setLctnAddr] = useState<string>();

    const svyrNmRef: any = useRef();
    const bthymd1Ref: any = useRef();
    const bthymd2Ref: any = useRef();
    const famyNoRef: any = useRef();
    const telNo1Ref: any = useRef();
    const telNo2Ref: any = useRef();
    const telNo3Ref: any = useRef();
    const mblTelno1Ref: any = useRef();
    const mblTelno2Ref: any = useRef();
    const mblTelno3Ref: any = useRef();
    const zpcdRef: any = useRef();
    const lctnAddr1Ref: any = useRef();
    const lctnAddr2Ref: any = useRef();
    const eaddrRef: any = useRef();


    const onCompletePost = (data: any) => {

        if (data['userSelectedType'] === 'R') {
            setLctnAddr(data['roadAddress']);
        } else {
            setLctnAddr(data['jibunAddress'])
        }
        setZpcd(data['zonecode']);
        setIsOpenPost(!isOpenPost);
    }

    const [isOpenPost, setIsOpenPost] = useState(false);
    const postCodeStyle: CSSProperties = {
        display: 'block',
        position: 'absolute',
        top: '0%',
        width: '500px',
        height: '500px',
        padding: '7px',
        zIndex: '1000',
        left: '350px'
    };

    //일련번호 존재여부 조회
    const OSUUF03R01 = async (csiSeq: string) => {
        const res = await callService("OSUUF03R01", {csiSeq : csiSeq});
        return res['issSeq'];
    }

    const getBirthday02 = () => {
        if (bthymd2Ref['current']['value'].length < 2) {
            return "0" + bthymd2Ref['current']['value'].toString();
        }
    }

    const onSubmit = async () => {
        const svyrNm = svyrNmRef['current']['value'];
        const gndr: any = document.querySelector('[name=radio-gndr]:checked');
        const bthymd = bthymd1Ref['current']['value'] + getBirthday02();
        const fmlyNo = famyNoRef['current']['value'];
        const telNo = (telNo2Ref['current']['value'] !== "" && telNo3Ref['current']['value'] !== "") ? (telNo1Ref['current']['value'] + "-" + telNo2Ref['current']['value'] + "-" + telNo3Ref['current']['value']) : "";
        const mblTelno = mblTelno1Ref['current']['value'] + "-" + mblTelno2Ref['current']['value'] + "-" + mblTelno3Ref['current']['value'];
        const zpcd = zpcdRef['current']['value'];
        const lctnAddr = lctnAddr1Ref['current']['value'] +" "+ lctnAddr2Ref['current']['value'];
        const eaddr = eaddrRef['current']['value'];
        const occupation: any = document.querySelector('[name=radio-occupation]:checked');
        const rsdDvCd: any = document.querySelector('[name=radio-rsdDvCd]:checked');
        const incomExpnDvCd: any = document.querySelector('[name=radio-incomExpnDvCd]:checked');

        const regHgulNmExp = /^[가-힣]{2,4}$/;
        const regNumExp = /^[0-9]+$/;
        const regYearExp = /^(19[0-9][0-9]|20\d{2})/;
        const regTelnoExp = /^(02|0[3-6]{1}[1-5]{1})-?([0-9]{3,4})-?[0-9]{4}$/;
        const regMblTelnoExp = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
        const regNumExpEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

        if (isEmpty(svyrNm)) {
            alert("세대주를 입력해주세요.");
            svyrNmRef['current'].focus();
            return;
        }
        if(svyrNm) {
            if(!regHgulNmExp.test(svyrNm)) {
                alert("세대주 성명이 올바르지 않습니다.");
                svyrNmRef['current'].focus();
                return;
            }
        }

        if (isEmpty(bthymd)) {
            alert("생년월일을 선택해주세요.");
            bthymd1Ref['current'].focus();
            return;
        }
        if(bthymd1Ref['current']['value']) {
            if(!regYearExp.test(bthymd1Ref['current']['value'])) {
                alert("생년월일이 유효하지 않습니다.");
                bthymd1Ref['current'].focus();
                return;
            }
        }

        if (isEmpty(fmlyNo) || fmlyNo === '0') {
            alert("세대 내 가족수(본인포함)을 입력해주세요.");
            famyNoRef['current'].focus();
            return;
        }
        if (!isEmpty(fmlyNo)) {
            if (!regNumExp.test(fmlyNo)) {
                alert("세대구성원 수는 숫자만 입력 가능합니다.");
                famyNoRef['current'].focus();
                return;
            }
        }

        if (telNo !== "") {
            if (!regTelnoExp.test(telNo)) {
                alert("전화번호가 올바르지 않습니다.");
                telNo2Ref['current'].focus();
                return;
            }
        }

        if (isEmpty(mblTelno1Ref['current']['value']) || isEmpty(mblTelno2Ref['current']['value']) || isEmpty(mblTelno3Ref['current']['value'])) {
            alert("휴대폰번호를 입력해주세요.");
            mblTelno2Ref['current'].focus();
            return;
        }
        if (!isEmpty(mblTelno)) {
            if (!regMblTelnoExp.test(mblTelno)) {
                alert("휴대폰번호가 올바르지 않습니다.");
                mblTelno2Ref['current'].focus();
                return;
            }
        }

        if (isEmpty(zpcd)) {
            alert("우편번호를 입력해주세요.");
            zpcdRef['current'].focus();
            return;
        }
        if (isEmpty(lctnAddr1Ref['current']['value']) || isEmpty(lctnAddr2Ref)) {
            alert("도로명주소 및 상세주소를 입력해주세요.")
            lctnAddr1Ref['current'].focus();
            return;
        }
        
        if (eaddr) {
            if (!regNumExpEmail.test(eaddr)) {
                alert('이메일 형식이 아닙니다.');
                eaddrRef['current'].focus();
                return;
            }
        }

        const issSeq = await OSUUF03R01(csiSeq);

        const param = {
            iudFlag: "I",
            csiSeq: csiSeq,
            issSeq: issSeq,
            svyrNm: svyrNm,
            gndr: gndr['value'],
            bthymd: bthymd,
            fmlyNo: fmlyNo,
            telNo: telNo ? telNo : "",
            mblTelno: mblTelno,
            zpcd: zpcd,
            lctnAddr: lctnAddr,
            eaddr: eaddr ? eaddr : "",
            occupation: occupation['value'],
            rsdDvCd: rsdDvCd['value'],
            incomExpnDvCd: incomExpnDvCd['value'],
            inptPathDvCd: '1'
        }
        const res = await callService("OSUUF03U01", param);
        
        if(res['resltCcnt'] === 1) {
            setCSISurveyPageNo(4);
        } else {
            alert("오류 발생");
        }
    }

    return (
        <>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="survey-step">
                    <div className="survey-step-top">
                        <p className="top-sub">한국은행 소비자동향조사</p>
                        <h2 className="top-tit">기초자료조사표</h2>
                    </div>
                    <div className="survey-step-box">
                        <div>
                            <ul className="survey-comment">
                                <li className="comment-li">
                                    귀댁의 세대상황에 대하여 해당사항을 기입하거나 "<span className="check-ex"></span>" 표하여 주십시오.
                                </li>
                                <li className="comment-li">
                                    조사표는 세대주께서 직접 작성하여 주시기 바랍니다.
                                </li>
                            </ul>
                            <fieldset>
                                <legend><span className="text-hide">기초자료조사표 작성하기</span></legend>
                                <div className="survey-form-group">
                                    <div className="form-line">
                                        <div className="form-group w456">
                                            <div className="input-box-group">
                                                <div className="input-box">
                                                    <label htmlFor="text-1" className="tit-txt">세대주 성명</label>
                                                    <div className="input-group">
                                                        <input className="form-control" type="text" id="text-1" placeholder="세대주 성명을 입력해주세요." ref={svyrNmRef} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group form-group-radio">
                                            <div className="input-box-group">
                                                <div className="input-box">
                                                    <label htmlFor="gender" className="tit-txt">성별</label>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-gndr" id="radio-1" value="1" defaultChecked={true} />
                                                        <label htmlFor="radio-1"><span>남성</span></label>
                                                    </div>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-gndr" id="radio-2" value="2" />
                                                        <label htmlFor="radio-2"><span>여성</span></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group w456">
                                            <div className="input-box-group">
                                                <div className="input-box input-box-select">
                                                    <label htmlFor="birth" className="tit-txt">생년월일</label>
                                                    <div className="input-group">
                                                        <input className="form-control w80" title="생년월일 선택" id="text" placeholder="년(4자)" ref={bthymd1Ref} maxLength={4} />
                                                        <span className="sub-txt">년</span>
                                                    </div>
                                                    <div className="input-group">
                                                        <select className="form-control w80" title="생년월일 선택" id="select-2" ref={bthymd2Ref}>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7</option>
                                                            <option value="8">8</option>
                                                            <option value="9">9</option>
                                                            <option value="10">10</option>
                                                            <option value="11">11</option>
                                                            <option value="12">12</option>
                                                        </select>
                                                        <span className="sub-txt">월</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group width50">
                                            <div className="input-box-group">
                                                <div className="input-box">
                                                    <label htmlFor="text" className="tit-txt">세대 내 가족수(본인포함)</label>
                                                    <div className="input-group ">
                                                        <input className="form-control w80" type="text" id="text" ref={famyNoRef} maxLength={4} />
                                                        <span className="sub-txt">명</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group w456">
                                            <div className="input-box-group">
                                                <div className="input-box input-box-select tel">
                                                    <label htmlFor="text-2" className="tit-txt">전화번호</label>
                                                    <div className="input-group">
                                                        <span className="sub-txt">자택</span>
                                                        <select className="form-control w80" id="tel" title="전화번호 선택" ref={telNo1Ref}>
                                                            <option value="02">02</option>
                                                            <option value="031">031</option>
                                                            <option value="032">032</option>
                                                            <option value="033">033</option>
                                                            <option value="041">041</option>
                                                            <option value="042">042</option>
                                                            <option value="043">043</option>
                                                            <option value="051">051</option>
                                                            <option value="052">052</option>
                                                            <option value="053">053</option>
                                                            <option value="054">054</option>
                                                            <option value="055">055</option>
                                                            <option value="061">061</option>
                                                            <option value="062">062</option>
                                                            <option value="063">063</option>
                                                            <option value="064">064</option>
                                                            <option value="070">070</option>
                                                        </select>
                                                    </div>
                                                    <div className="input-group">
                                                        <input className="form-control w80" type="text" id="text-3" ref={telNo2Ref} maxLength={4} />
                                                    </div>
                                                    <div className="dash">-</div>
                                                    <div className="input-group">
                                                        <input className="form-control w80" type="text" id="text-4" ref={telNo3Ref} maxLength={4} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="input-box-group">
                                                <div className="input-box tel">
                                                    <label htmlFor="phone" className="tit-txt">휴대폰</label>
                                                    <div className="input-group">
                                                        <input className="form-control w80" type="text" id="text-5" title="휴대폰번호 선택" ref={mblTelno1Ref} maxLength={3} />
                                                    </div>
                                                    <div className="dash">-</div>
                                                    <div className="input-group">
                                                        <input className="form-control w80" type="text" id="text-6" ref={mblTelno2Ref} maxLength={4} />
                                                    </div>
                                                    <div className="dash">-</div>
                                                    <div className="input-group">
                                                        <input className="form-control w80" type="text" id="text-7" ref={mblTelno3Ref} maxLength={4} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group">
                                            <div className="input-box-group">
                                                <div className="input-box address">
                                                    <label htmlFor="text-7" className="tit-txt">주소</label>
                                                    <div className="input-group">
                                                        <input className="form-control" type="text" id="text-7" ref={zpcdRef} maxLength={5} value={zpcd && zpcd} readOnly />
                                                        <button type="button" className="btn btn-search" onClick={() => setIsOpenPost(true)} >우편번호 검색</button>
                                                        {isOpenPost && <DaumPostcode autoClose onComplete={(data) => onCompletePost(data)} style={postCodeStyle} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group add-pl">
                                            <div className="input-box-group">
                                                <div className="input-box">
                                                    <label htmlFor="text-8" className="tit-txt">도로명주소</label>
                                                    <div className="input-group">
                                                        <input className="form-control" type="text" id="text-8" placeholder="우편번호검색을 진행해주세요." ref={lctnAddr1Ref} value={lctnAddr && lctnAddr} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group add-pl">
                                            <div className="input-box-group">
                                                <div className="input-box">
                                                    <label htmlFor="text-9" className="tit-txt">상세주소</label>
                                                    <div className="input-group">
                                                        <input className="form-control" type="text" id="text-9" placeholder="상세주소를 입력해주세요." ref={lctnAddr2Ref} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group">
                                            <div className="input-box-group">
                                                <div className="input-box input-box-select clearfix">
                                                    <label htmlFor="text-10" className="tit-txt">E-mail</label>
                                                    <div className="input-group">
                                                        <input className="form-control email" type="text" id="text-10" placeholder="이메일을 입력해주세요." style={{ width: "582px" }} ref={eaddrRef} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group form-group-radio">
                                            <div className="input-box-group pdt10">
                                                <div className="input-box">
                                                    <label htmlFor="jobs" className="tit-txt">직업</label>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-occupation" id="radio-5" value="1" defaultChecked={true} />
                                                        <label htmlFor="radio-5"><span>근로자</span></label>
                                                    </div>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-occupation" id="radio-6" value="2" />
                                                        <label htmlFor="radio-6"><span>자영업자</span></label>
                                                    </div>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-occupation" id="radio-7" value="3" />
                                                        <label htmlFor="radio-7"><span>기타(무직포함)</span></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="p-txt">직업은 가계의 주된 수입원을 기준으로 표시해 주시기 바랍니다.</div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group form-group-radio">
                                            <div className="input-box-group pd10">
                                                <div className="input-box">
                                                    <label htmlFor="residence" className="tit-txt">주거상황</label>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-rsdDvCd" id="radio-8" value="1" defaultChecked={true} />
                                                        <label htmlFor="radio-8"><span>자가</span></label>
                                                    </div>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-rsdDvCd" id="radio-9" value="2" />
                                                        <label htmlFor="radio-9"><span>전세</span></label>
                                                    </div>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-rsdDvCd" id="radio-10" value="3" />
                                                        <label htmlFor="radio-10"><span>월세</span></label>
                                                    </div>
                                                    <div className="input-group input-group-radio">
                                                        <input className="form-control" type="radio" name="radio-rsdDvCd" id="radio-11" value="4" />
                                                        <label htmlFor="radio-11"><span>기타</span></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-line">
                                        <div className="form-group form-group-radio">
                                            <div className="input-box-group">
                                                <div className="input-box income-inner">
                                                    <label htmlFor="income" className="tit-txt">월평균 가구<br />총수입</label>
                                                    <ul className="layout-wrap">
                                                        <li>
                                                            <div className="input-group ">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-12" value="1" defaultChecked={true} />
                                                                <label htmlFor="radio-12"><span>100만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-13" value="2" />
                                                                <label htmlFor="radio-13"><span>100~200만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-14" value="3" />
                                                                <label htmlFor="radio-14"><span>200~300만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-15" value="4" />
                                                                <label htmlFor="radio-15"><span>300~400만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <ul className="layout-wrap">
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-16" value="5" />
                                                                <label htmlFor="radio-16"><span>400~500만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-17" value="6" />
                                                                <label htmlFor="radio-17"><span>500~600만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-18" value="7" />
                                                                <label htmlFor="radio-18"><span>600~700만원 미만</span></label>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="input-group">
                                                                <input className="form-control" type="radio" name="radio-incomExpnDvCd" id="radio-19" value="8" />
                                                                <label htmlFor="radio-19"><span>700만원 이상</span></label>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="p-txt">월평균 가구 총수입은 <span className="underline">세대수 포함 세대내 모든 가족의 수입</span>으로서 <span className="underline">근로소득 외에 이자소득,연금소득 등도 포함</span>됩니다.</div>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                        <div className="btn-group">
                            <button type="button" className="btn btn-popup positive" title="기초자료조사표 입력완료." onClick={() => onSubmit()}>입력완료</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const CSISurveyPage4 = ({ msg, history }: any) => {

    return (
        <>
            <div className="wrap-body-center">
                <div className="bg"></div>
                <div className="survey-step">
                    <div className="survey-step-box">
                        <div>
                            <h2 className="survey-info-tit">협조해주셔서 감사드립니다.</h2>
                            <div className="survey-step-p">
                                <p className="survey-info">
                                    '소비자동향조사 의향조사'에 협조해주셔서 대단히 감사드립니다. <br />
                                    <span className="txt-b">본 조사에 참여하시는 가구에 대해서는 감사의 마음으로 소정의 답례품을 보내드립니다.</span> <br />
                                    많은 관심과 협조 부탁드립니다.감사합니다.
                                </p>
                            </div>
                        </div>
                        <div className="btn-group">
                            <button type="button" className="btn btn-popup positive" title="기초자료조사표 닫기." onClick={() => history.push('/')}>닫기</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const CSISurvey = ({ msg }: any) => {

    const [CSISurveyPageNo, setCSISurveyPageNo] = useState<number>(1);

    const [csiSeq, setCsiSeq] = useState<string>('');

    const history = useHistory();


    return (
        <>
            {
                CSISurveyPageNo === 1 ?
                    <CSISurveyPage1 setCSISurveyPageNo={setCSISurveyPageNo} setCsiSeq={setCsiSeq} />
                    :
                    CSISurveyPageNo === 2 ?
                        <CSISurveyPage2 msg={msg} setCSISurveyPageNo={setCSISurveyPageNo} />
                        :
                        CSISurveyPageNo === 3 ?
                            <CSISurveyPage3 msg={msg} setCSISurveyPageNo={setCSISurveyPageNo} csiSeq={csiSeq} />
                            :
                            CSISurveyPageNo === 4 &&
                            <CSISurveyPage4 msg={msg} history={history} />
            }
        </>
    )

}

export default CSISurvey